import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	button: {
		minWidth: 300
	}
})

export default useStyles
